import { render, staticRenderFns } from "./AttrPanel.vue?vue&type=template&id=07e57ae9&scoped=true"
import script from "./AttrPanel.vue?vue&type=script&lang=js"
export * from "./AttrPanel.vue?vue&type=script&lang=js"
import style0 from "./AttrPanel.vue?vue&type=style&index=0&id=07e57ae9&prod&lang=less&scoped=true"


/* normalize component */
import normalizer from "!../../../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "07e57ae9",
  null
  
)

export default component.exports